// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".clients-list[data-v-ef54127c]{max-height:400px;overflow-y:auto;border:1px solid #e0e0e0;border-radius:4px}", ""]);
// Exports
module.exports = exports;
